import React from 'react';

import { CharacterCounter } from './CharacterCounter';
import { FormItem } from './FormItem';
import { FormRow } from './FormRow';

interface IFormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  inputMode?: 'search' | 'text' | 'none' | 'numeric' | 'email' | 'tel' | 'url' | 'decimal';
}

export class Form extends React.Component<IFormProps> {
  static Item = FormItem;
  static CharacterCounter = CharacterCounter;
  static Row = FormRow;

  render() {
    return <form {...this.props}>{this.props.children}</form>;
  }
}
